import React from "react";
import { Link } from "react-router-dom";
import { Table, Card, Badge } from "reactstrap";

export interface OrderRow {
  id: string;
  name: string;
  status: string;
  amount: string;
  date: string;
  color: string;
  listingId?: string | null;
}

const DEFAULT_ORDERS: OrderRow[] = [
  { id: "—", name: "—", status: "—", amount: "—", date: "—", color: "secondary" },
];

interface LatestOrdersProps {
  orders?: OrderRow[];
}

const LatestOrders = (props: LatestOrdersProps) => {
  const orders = props.orders?.length ? props.orders : DEFAULT_ORDERS;

  return (
    <Card>
      <div className="card-body">
        <h4 className="card-title mb-4">Latest Orders / Listings</h4>
        <div className="table-responsive">
          <Table className="align-middle table-centered table-vertical table-nowrap mb-1">
            <tbody>
              {orders.map((order, key) => (
                <tr key={key}>
                  <td>
                    {order.listingId ? (
                      <Link to={`/property/${order.listingId}`}>{order.name}</Link>
                    ) : (
                      order.name
                    )}
                  </td>
                  <td>
                    <Badge className={"rounded-pill bg-" + order.color}>{order.status}</Badge>
                  </td>
                  <td>{order.amount}</td>
                  <td>{order.date}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </Card>
  );
};

export default LatestOrders;